import { HeartIcon as HeartOutline } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { BookmarkIcon as BookmarkOutline } from "@heroicons/react/24/outline";
import { BookmarkIcon as BookmarkSolid } from "@heroicons/react/24/solid";
import {
  ChatBubbleOvalLeftIcon,
  ShareIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/24/outline";
import avatar from "../../assets/images/Avatar.avif"

import MainButton from "../sharedComponents/MainButton";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { toggleLike } from "../../slices/5-like/thunk";
import { toggleBookmark } from "../../slices/4-bookmark/thunk";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const SponsoredPost = ({
  post,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  // console.log(post)
  const locale = i18n.language === "ar" ? "ar" : "en";

  const handleShare = async () => {
    const url = `${window.location.origin}/post/${post?.id}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: post?.title || "Check this post",
          text: post?.content?.slice(0, 100) || "Interesting post",
          url,
        });
      } catch (err) {
        // console.log("Share cancelled", err);
      }
    } else {
      await navigator.clipboard.writeText(url);
    }
  };

  // console.log(post)
  return (
    <div
      className="overflow-hidden duration-300 border bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate(`/profile-company/${post?.Company?.slug}`)}
        >
          <img
            src={post?.Company?.logo || avatar}
            className="w-10 h-10 rounded-full" alt="avatar" />
          <div>
            <p className="font-semibold text-gray-900 dark:text-gray-100">
              {locale === "ar" ? post?.Company?.name_AR : post?.Company?.name_EN}

            </p>
            <span className="text-xs text-text-muted-light dark:text-text-muted-dark">{t("postType.sponsored")}</span>
          </div>
        </div>
        <button className="p-2 duration-300 rounded-xl dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary group">
          <EllipsisHorizontalIcon className="w-5 h-5 duration-300 text-text-muted-light dark:text-text-muted-dark dark:group-hover:text-primary group-hover:text-primary-light" />
        </button>{" "}
      </div>

      {/* Text */}
      <div className="px-4 pb-3">
        <p className="text-sm text-gray-700 cursor-pointer dark:text-gray-300"
          onClick={() => navigate(`/post/${post?.id}`)}

        >{post?.text}</p>
        {/* <p className="text-sm text-gray-700 dark:text-gray-300">{post.description}</p> */}
      </div>

      {/* Image */}
      {post?.image &&
        <img src={post?.image} alt="iamge post" className="object-cover w-full h-64 cursor-pointer"
          onClick={() => navigate(`/post/${post?.id}`)}

        />
      }

      {/* CTA */}
      <div className="flex items-center justify-end p-4 dark:bg-bg-dark-tertiary bg-bg-light-tertiary">
        {/* <div>
          <p className="text-sm text-black dark:text-white">{t("ads.title")}</p>
          <p className="text-sm text-black dark:text-white">{t("ads.description")}</p>
        </div> */}

        <MainButton
          onClick={() => window.open(post?.url, "_blank")}
        >
          {t("ads.button")}
        </MainButton>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between p-4 text-gray-500 dark:text-gray-400">
        <div className="flex items-center gap-2">
          {/* LOVE */}
          <div
            onClick={() => {
              dispatch(toggleLike(post?.id));
            }}
            className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
          >
            {post?.liked ? (
              <HeartSolid className="w-5 h-5 text-red-500" />
            ) : (
              <HeartOutline className="w-5 h-5 text-red-500" />
            )}
            <span className="text-sm text-red-500">
              {Math.max(0, post?.likeCount || 0)}
            </span>
          </div>

          {/* COMMENT */}
          <div className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:text-primary hover:text-primary-light dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
            onClick={() => navigate(`/post/${post?.id}`)}

          >
            <ChatBubbleOvalLeftIcon className="w-5 h-5" />
            <span className="text-sm">{post?.Comments?.length}</span>
          </div>

          {/* SHARE */}
          <div className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:text-primary hover:text-primary-light dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary "
            onClick={handleShare}
          >
            <ShareIcon className="w-5 h-5" />
            {/* <span className="text-sm">{post?.sharesCount}</span> */}
          </div>
        </div>

        {/* BOOKMARK */}
        <div
          onClick={() => {
            dispatch(toggleBookmark(post?.id));
          }}
          className="p-2 duration-300 rounded-lg cursor-pointer dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
        >
          {post?.bookmarked ? (
            <BookmarkSolid className="w-5 h-5 dark:text-primary text-primary-light" />
          ) : (
            <BookmarkOutline className="w-5 h-5 dark:text-primary text-primary-light" />
          )}
        </div>
      </div>
    </div>
  );
};
export default SponsoredPost;
